import { render, staticRenderFns } from "./IrisCard.vue?vue&type=template&id=4598f2c0&"
import script from "./IrisCard.vue?vue&type=script&lang=ts&"
export * from "./IrisCard.vue?vue&type=script&lang=ts&"
import style0 from "./IrisCard.vue?vue&type=style&index=0&id=4598f2c0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports